export default __webpack_public_path__ + "static/media/MAUI-mark.84ca2d42.svg";